import api from "@/services/api";
import { Component, Watch } from "vue-property-decorator";
import gridComponentBase from "../../../components/grid/gridComponentBase.vue";
import permessi from "@/config/permessi";

@Component({})
export default class ricercaGaranzieClienti extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Vendite.ADESIONI_POLIZZE_CLIENTI];
	}
	
}
